import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PropertyImageService {
}
/**
* Sorts an array of PropertyImage **only** when at least one image has a numeric sortOrder.
* Otherwise the original order is returned unchanged.
*/
export function sortImagesIfNeeded<T extends { sortOrder?: number | null }>(
    images: T[]
    ): T[] {
    // 1. Does ANY image have a real sortOrder?
    const hasSortOrder = images.some(img => typeof img.sortOrder === 'number');

    if (!hasSortOrder) {
    return images;               // nothing to do
    }

    // 2. Clone + stable sort (preserves relative order when sortOrder is equal)
    return [...images].sort((a, b) => {
    const aVal = a.sortOrder ?? 0;
    const bVal = b.sortOrder ?? 0;
    return aVal - bVal;          // ascending
    });
}